import script from "./Main-UI.vue?vue&type=script&setup=true&lang=js"
export * from "./Main-UI.vue?vue&type=script&setup=true&lang=js"

import "./Main-UI.vue?vue&type=style&index=0&id=db877eb2&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-db877eb2"]])

export default __exports__